/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1ReferralCodeInfo
 */
export interface V1ReferralCodeInfo {
    /**
     *
     */
    programId: string
    /**
     *
     */
    referrerLogin: string
    /**
     *
     */
    landingPath: string
    /**
     *
     */
    active: boolean
}

/**
 * Check if a given object implements the V1ReferralCodeInfo interface.
 */
export function instanceOfV1ReferralCodeInfo(
    value: object
): value is V1ReferralCodeInfo {
    if (!('programId' in value) || value['programId'] === undefined)
        return false
    if (!('referrerLogin' in value) || value['referrerLogin'] === undefined)
        return false
    if (!('landingPath' in value) || value['landingPath'] === undefined)
        return false
    if (!('active' in value) || value['active'] === undefined) return false
    return true
}

export function V1ReferralCodeInfoFromJSON(json: any): V1ReferralCodeInfo {
    return V1ReferralCodeInfoFromJSONTyped(json, false)
}

export function V1ReferralCodeInfoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1ReferralCodeInfo {
    if (json == null) {
        return json
    }
    return {
        programId: json['programId'],
        referrerLogin: json['referrerLogin'],
        landingPath: json['landingPath'],
        active: json['active']
    }
}

export function V1ReferralCodeInfoToJSON(json: any): V1ReferralCodeInfo {
    return V1ReferralCodeInfoToJSONTyped(json, false)
}

export function V1ReferralCodeInfoToJSONTyped(
    value?: V1ReferralCodeInfo | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        programId: value['programId'],
        referrerLogin: value['referrerLogin'],
        landingPath: value['landingPath'],
        active: value['active']
    }
}
